import React from 'react';

const Header = ({ nodes, search }) => (
  <section className="block-section header">
    <h1 className="brand-title">Klantenservice</h1>
    {nodes && (
      <div className="breadcrumbs unstyled-list">
        <ol className="breadcrumb">
          <li>
            <a href="/">Klantenservice</a>
          </li>
          {nodes &&
            nodes.map(
              node =>
                node && (
                  <li key={node.nodeId}>
                    <a href={`/${node.nodeId}`}>{node.displayText}</a>
                  </li>
                )
            )}
        </ol>
      </div>
    )}
    {search && (
      <div className="breadcrumbs unstyled-list">
        <ol className="breadcrumb">
          <li>
            <a href="/">Klantenservice</a>
          </li>
          <li>
            <a href={`/results/${search}`}>
              U zoekt '{search}' in klantenservice
            </a>
          </li>
        </ol>
      </div>
    )}
  </section>
);

export default Header;
